import { get } from '../base';

import { TimeZonesResponse } from './types-get-timezones';

export const getTimezones = (): Promise<TimeZonesResponse> => {
  return get('v5/timezones').json();
};
